/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import MISC from '@/js/miscellaneous.js'
import PARSE from '@/js/parse.js'

const ipLoopBack = `${process.env.VUE_APP_URL}`
const ipBankbook = 'https://bankbook.diopen.ml'

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    resolve(reader.result);
  } 
  reader.onerror = error => reject(error);
});

function recognizeImpl (base64Bytes, url, kwargs = {}, headers) {
  return new Promise(function (resolve, reject) {
    try {
      fetch(
        url,
        {
          method: 'POST',
          mode: 'cors',
          body: base64Bytes ? JSON.stringify({data: base64Bytes, ...kwargs}) : JSON.stringify({...kwargs}),
          headers: headers ?  headers : {
            'Content-Type': 'application/json'
          },
          timeout: 30
        }
      ).then((response) => {
        return response.json()
      }
      ).then((ret) => {
        if (ret.code && ret.code != 0) {
          reject('인식 서버 오류, code: ' + ret.code)
          return
        }
        if (ret.status && ret.status != 0) {
          reject('인식 서버 오류, code: ' + ret.code)
          return
        }
        resolve(ret)
      }).catch(error => reject(error + ''));
    } catch (e) {
      reject('timeout')
    }
  })
}

async function recognizeDocumentClassification (file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/classifier/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/classifier/inference`);
    
  return {data: ret.data};
}

async function recognizeBusinessRegistration (file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/br/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/br/inference`);
  
  if (ret.data.fields == undefined)
    throw 'invalid response'
  
  const image = await PARSE.parseJpg(MISC.convertBase64ToBuffer(ret.image));
  return {data: ret.data, image};
}

async function recognizeNutritionalInformation (file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/ni/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/ni/inference`);
    
  return {data: ret.data};
}

async function recognizePassport (file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/passport/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/passport/inference`);
  
  if (ret.data.fields == undefined)
    throw 'invalid response'
  
  const image = await PARSE.parseJpg(MISC.convertBase64ToBuffer(ret.image));
  return {data: ret.data, image};
}

async function recognizeIdcard (file, autoCrop) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/ic/inference`, { autoCrop });
    return ret;
  }
  
  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/ic/inference`, { autoCrop });
  
  return {data: ret.data};
}

async function recognizeTable1 (file, withOcr) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/table/inference`, { withOcr, methodNum: 1 });
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/table/inference`, { withOcr, methodNum: 1 });
  
  return {data: ret.data};
}

async function recognizeTable2 (file, withOcr) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/table/inference`, { withOcr, methodNum: 2 });
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/table/inference`, { withOcr, methodNum: 2 });
  
  return {data: ret.data};
}

async function recognizeCreditcard (file, useDirectionCls) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/credit/inference`, { useDirectionCls });
    return ret;
  }
  
  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/credit/inference`, { useDirectionCls });
  
  return {data: ret.data};
}

async function recognizeBankbook (file) {
  let base64Bytes = await toBase64(file);
  const data = {
      documentId : "0",
      base64Image: base64Bytes
  }

  const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/bankbook/inference`, data);

  return {data: ret};
}

async function recognizeDocumentLayoutAnalysis(file, usePost) {
  let base64Bytes = await toBase64(file);
  const data = {
      applyPostprocessing : usePost,
      base64Image: base64Bytes
  }

  const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/dla/inference`, data);

  return {data: ret};
}

async function recognizeFamilyRelations (file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/fr/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/fr/inference`);
  
  const image = await PARSE.parseJpg(MISC.convertBase64ToBuffer(ret.image));
  return {data: ret.data, image};
}

async function recognizeGeneralTable (file, config) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/gt/inference`);
    return ret;
  }

  const config_ret = await recognizeImpl(config, `${ipLoopBack}/api/document/gt/inference`);
  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/gt/inference`);
  
  return {config: config_ret.data, data: ret.data};
}

async function recognizePrescription (file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/prescription/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/prescription/inference`);
  return {data: ret.data};
}

async function recognizeFinancialStatement (file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/financial/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/financial/inference`);
    
  if (ret.data.fields == undefined)
    throw 'invalid response'

  const image = await PARSE.parseJpg(MISC.convertBase64ToBuffer(ret.image));
  return {data: ret.data, image};
}

async function recognizeTrafficFine (file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/traffic/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/traffic/inference`);
    
  if (ret.data.fields == undefined)
    throw 'invalid response'

  const image = await PARSE.parseJpg(MISC.convertBase64ToBuffer(ret.image));
  return {data: ret.data, image};
}

async function recognizeMedicalDetailed (file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/medicaldetailed/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/medicaldetailed/inference`);
    
  if (ret.data.fields == undefined)
    throw 'invalid response'

  const image = await PARSE.parseJpg(MISC.convertBase64ToBuffer(ret.image));
  return {data: ret.data, image};
}

async function recognizeUltraimage(file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/ultrasound/inference`);
    return ret;
  }
  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/ultrasound/inference`);
  return {data: ret.data};
}

async function recognizeTestPaper (file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/testpaper/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/document/testpaper/inference`);
    
  if (ret.data == undefined)
    throw 'invalid response'

  const image = await PARSE.parseJpg(MISC.convertBase64ToBuffer(ret.image));
  return {data: ret.data, image};
}

async function recognizeRemoveHandwriting(file) {
  let base64Bytes = await toBase64(file);
  const data = {
      base64Image: base64Bytes
  }

  const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/remove_handwriting/inference`, data);
  const image = await PARSE.parseJpg(MISC.convertBase64ToBuffer(ret.base64Image));

  return {data: { base64Image: ret.base64Image }, image};
}


const omr_keys = new Map([
  ['', ''],
  ['__', ''],
  ['[', ''],
  [']', ''],
  ['type', '템플릿 종류'],
  ["순번", "순번"],
  ["교시", "교시"],
  ["학년", "학년"],
  ["수험번호/반/0", "수험번호_반"],
  ["수험번호/반/1", "수험번호_반"],
  ["수험번호/번호/0", "수험번호_번호"],
  ["수험번호/번호/1", "수험번호_번호"],
  ["수험번호/번호/2", "수험번호_번호"],
  ["수험번호/번호/3", "수험번호_번호"],

  ["성명/0/0", "성명"],
  ["성명/0/1", "성명"],
  ["성명/0/2", "성명"],
  ["성명/1/0", "성명"],
  ["성명/1/1", "성명"],
  ["성명/1/2", "성명"],
  ["성명/2/0", "성명"],
  ["성명/2/1", "성명"],
  ["성명/2/2", "성명"],
  ["성명/3/0", "성명"],
  ["성명/3/1", "성명"],
  ["성명/3/2", "성명"],

  ["생년월일/년/0", "생년월일"],
  ["생년월일/년/1", "생년월일"],
  ["생년월일/월/0", "생년월일"],
  ["생년월일/월/1", "생년월일"],
  ["생년월일/일/0", "생년월일"],
  ["생년월일/일/1", "생년월일"],

  ["탐구선택1/0", "탐구선택1"],
  ["탐구선택1/1", "탐구선택1"],
  ["탐구선택2/0", "탐구선택2"],
  ["탐구선택2/1", "탐구선택2"],

  ["계열", "계열"],
  ["선택", "선택"],

  ["탐구1/문번/1", "탐구_1_문제번호_1"],
  ["탐구1/문번/2", "탐구_1_문제번호_2"],
  ["탐구1/문번/3", "탐구_1_문제번호_3"],
  ["탐구1/문번/4", "탐구_1_문제번호_4"],
  ["탐구1/문번/5", "탐구_1_문제번호_5"],
  ["탐구1/문번/6", "탐구_1_문제번호_6"],
  ["탐구1/문번/7", "탐구_1_문제번호_7"],
  ["탐구1/문번/8", "탐구_1_문제번호_8"],
  ["탐구1/문번/9", "탐구_1_문제번호_9"],
  ["탐구1/문번/10", "탐구_1_문제번호_10"],
  ["탐구1/문번/11", "탐구_1_문제번호_11"],
  ["탐구1/문번/12", "탐구_1_문제번호_12"],
  ["탐구1/문번/13", "탐구_1_문제번호_13"],
  ["탐구1/문번/14", "탐구_1_문제번호_14"],
  ["탐구1/문번/15", "탐구_1_문제번호_15"],
  ["탐구1/문번/16", "탐구_1_문제번호_16"],
  ["탐구1/문번/17", "탐구_1_문제번호_17"],
  ["탐구1/문번/18", "탐구_1_문제번호_18"],
  ["탐구1/문번/19", "탐구_1_문제번호_19"],
  ["탐구1/문번/20", "탐구_1_문제번호_20"],

  ["탐구2/문번/1", "탐구_2_문제번호_1"],
  ["탐구2/문번/2", "탐구_2_문제번호_2"],
  ["탐구2/문번/3", "탐구_2_문제번호_3"],
  ["탐구2/문번/4", "탐구_2_문제번호_4"],
  ["탐구2/문번/5", "탐구_2_문제번호_5"],
  ["탐구2/문번/6", "탐구_2_문제번호_6"],
  ["탐구2/문번/7", "탐구_2_문제번호_7"],
  ["탐구2/문번/8", "탐구_2_문제번호_8"],
  ["탐구2/문번/9", "탐구_2_문제번호_9"],
  ["탐구2/문번/10", "탐구_2_문제번호_10"],
  ["탐구2/문번/11", "탐구_2_문제번호_11"],
  ["탐구2/문번/12", "탐구_2_문제번호_12"],
  ["탐구2/문번/13", "탐구_2_문제번호_13"],
  ["탐구2/문번/14", "탐구_2_문제번호_14"],
  ["탐구2/문번/15", "탐구_2_문제번호_15"],
  ["탐구2/문번/16", "탐구_2_문제번호_16"],
  ["탐구2/문번/17", "탐구_2_문제번호_17"],
  ["탐구2/문번/18", "탐구_2_문제번호_18"],
  ["탐구2/문번/19", "탐구_2_문제번호_19"],
  ["탐구2/문번/20", "탐구_2_문제번호_20"],
  
  ["지망대학1/0", "지망대학1"],
  ["지망대학1/1", "지망대학1"],
  ["지망대학1/2", "지망대학1"],
  ["지망대학1/3", "지망대학1"],
  ["지망대학1/4", "지망대학1"],
  ["지망대학1/5", "지망대학1"],
  ["지망대학1/6", "지망대학1"],

  ["지망대학2/0", "지망대학2"],
  ["지망대학2/1", "지망대학2"],
  ["지망대학2/2", "지망대학2"],
  ["지망대학2/3", "지망대학2"],
  ["지망대학2/4", "지망대학2"],
  ["지망대학2/5", "지망대학2"],
  ["지망대학2/6", "지망대학2"],

  ["문번/1", "문제번호_1"],
  ["문번/2", "문제번호_2"],
  ["문번/3", "문제번호_3"],
  ["문번/4", "문제번호_4"],  
  ["문번/5", "문제번호_5"],
  ["문번/6", "문제번호_6"],
  ["문번/7", "문제번호_7"],
  ["문번/8", "문제번호_8"],
  ["문번/9", "문제번호_9"],
  ["문번/10", "문제번호_10"],
  ["문번/11", "문제번호_11"],
  ["문번/12", "문제번호_12"],
  ["문번/13", "문제번호_13"],
  ["문번/14", "문제번호_14"],
  ["문번/15", "문제번호_15"],
  ["문번/16", "문제번호_16"],
  ["문번/16/0", "문제번호_16"],
  ["문번/16/1", "문제번호_16"],
  ["문번/16/2", "문제번호_16"],
  ["문번/17", "문제번호_17"],
  ["문번/17/0", "문제번호_17"],
  ["문번/17/1", "문제번호_17"],
  ["문번/17/2", "문제번호_17"],
  ["문번/18", "문제번호_18"],
  ["문번/18/0", "문제번호_18"],
  ["문번/18/1", "문제번호_18"],
  ["문번/18/2", "문제번호_18"],
  ["문번/19", "문제번호_19"],
  ["문번/19/0", "문제번호_19"],
  ["문번/19/1", "문제번호_19"],
  ["문번/19/2", "문제번호_19"],
  ["문번/20", "문제번호_20"],
  ["문번/20/0", "문제번호_20"],
  ["문번/20/1", "문제번호_20"],
  ["문번/20/2", "문제번호_20"],
  ["문번/21", "문제번호_21"],
  ["문번/21/0", "문제번호_21"],
  ["문번/21/1", "문제번호_21"],
  ["문번/21/2", "문제번호_21"],
  ["문번/22", "문제번호_22"],
  ["문번/22/0", "문제번호_22"],
  ["문번/22/1", "문제번호_22"],
  ["문번/22/2", "문제번호_22", ],
  ["문번/23", "문제번호_23"],
  ["문번/24", "문제번호_24"],
  ["문번/25", "문제번호_25"],
  ["문번/26", "문제번호_26"],
  ["문번/27", "문제번호_27"],
  ["문번/28", "문제번호_28"],
  ["문번/29", "문제번호_29"],
  ["문번/29/0", "문제번호_29"],
  ["문번/29/1", "문제번호_29"],
  ["문번/29/2", "문제번호_29"],
  ["문번/30", "문제번호_30"],
  ["문번/30/0", "문제번호_30"],
  ["문번/30/1", "문제번호_30"],
  ["문번/30/2", "문제번호_30"],
  ["문번/31", "문제번호_31"],
  ["문번/32", "문제번호_32"],
  ["문번/33", "문제번호_33"],
  ["문번/34", "문제번호_34"],
  ["문번/35", "문제번호_35"],
  ["문번/36", "문제번호_36"],
  ["문번/37", "문제번호_37"],
  ["문번/38", "문제번호_38"],
  ["문번/39", "문제번호_39"],
  ["문번/40", "문제번호_40"],
  ["문번/41", "문제번호_41"],
  ["문번/42", "문제번호_42"],
  ["문번/43", "문제번호_43"],
  ["문번/44", "문제번호_44"],
  ["문번/45", "문제번호_45"],
]);

const cho_map = new Map([
  ["A", "ᄀ"], // unicode: U+1100
  ["O", "ᄁ"],
  ["B", "ᄂ"],
  ["C", "ᄃ"],
  ["P", "ᄄ"],
  ["D", "ᄅ"],
  ["E", "ᄆ"],
  ["F", "ᄇ"],
  ["Q", "ᄈ"],
  ["G", "ᄉ"],
  ["R", "ᄊ"],
  ["H", "ᄋ"],
  ["I", "ᄌ"],
  ["S", "ᄍ"],
  ["J", "ᄎ"],
  ["K", "ᄏ"],
  ["L", "ᄐ"],
  ["M", "ᄑ"],
  ["N", "ᄒ"]  
]);

const jung_map = new Map([
  ["A", "ᅡ" ], // unicode: U+1161
  ["K", "ᅢ" ], // unicode: U+1162
  ["B", "ᅣ" ], // unicode: U+1163
  ["L", "ᅤ" ], // unicode: U+1164
  ["C", "ᅥ" ], // unicode: U+1165
  ["M", "ᅦ" ], // unicode: U+1166
  ["D", "ᅧ" ], // unicode: U+1167
  ["N", "ᅨ" ],
  ["E", "ᅩ" ],
  ["O", "ᅪ" ],
  ["X", "ᅫ" ],
  ["P", "ᅬ" ],
  ["F", "ᅭ" ],
  ["G", "ᅮ" ],
  ["Q", "ᅯ" ],
  ["Y", "ᅰ" ],
  ["R", "ᅱ" ],
  ["H", "ᅲ" ],
  ["I", "ᅳ" ],
  ["S", "ᅴ" ],
  ["J", "ᅵ" ]
]);

const jong_map = new Map([
  ["A","ᆨ"], // unicode: U+11A8
  ["O","ᆩ"],
  ["B","ᆫ"],
  ["c","ᆭ"],
  ["C","ᆮ"],
  ["D","ᆯ"],
  ["d","ᆰ"],
  ["e","ᆱ"],
  ["f","ᆲ"],
  ["j","ᆶ"],
  ["E","ᆷ"],
  ["F","ᆸ"],
  ["G","ᆺ"],
  ["R","ᆻ"],
  ["H","ᆼ"],
  ["I","ᆽ"],
  ["J","ᆾ"],
  ["K","ᆿ"],
  ["L","ᇀ"],
  ["M","ᇁ"],
  ["N","ᇂ"]  
]);

const makeHangul = (cho, jung, jong) => {
  const CHO = "\u1100\u1101\u1102\u1103\u1104\u1105\u1106\u1107\u1108\u1109\u110A\u110B\u110C\u110D\u110E\u110F\u1110\u1111\u1112\u1113\u1114\u1115\u1116\u1117\u1118\u1119\u111A\u111B\u111C\u111D\u111E\u111F";
  const JUNG = "\u1161\u1162\u1163\u1164\u1165\u1166\u1167\u1168\u1169\u116A\u116B\u116C\u116D\u116E\u116F\u1170\u1171\u1172\u1173\u1174\u1175\u1176\u1177\u1178\u1179\u117A\u117B\u117C\u117D\u117E\u117F";
  const JONG = "\0\u11A8\u11A9\u11AA\u11AB\u11AC\u11AD\u11AE\u11AF\u11B0\u11B1\u11B2\u11B3\u11B4\u11B5\u11B6\u11B7\u11B8\u11B9\u11BA\u11BB\u11BC\u11BD\u11BE\u11BF\u11C0\u11C1\u11C2\u11C3\u11C4\u11C5\u11C6\u11C7"; // 공백 포함

  const choIndex = CHO.indexOf(cho);
  const jungIndex = JUNG.indexOf(jung);
  const jongIndex = JONG.indexOf(jong);
  if (choIndex === -1 || jungIndex === -1 || (jong && jongIndex === -1)) {
      throw new Error("잘못된 입력값입니다.");
  }

  const unicode = 0xAC00 + (choIndex * 21 * 28) + (jungIndex * 28) + (jongIndex >= 0 ? jongIndex : 0);
  return String.fromCharCode(unicode);
}


const convertOMRKeys = (data) => {
  const convertName = (code_list) => {
    let name = '';
    for (let i = 0; i < code_list.length; i = i + 3) {
      const cho = code_list[i];
      const jung = code_list[i + 1];
      const jong = code_list[i + 2];
      name += makeHangul(cho_map.get(cho), jung_map.get(jung), jong_map.get(jong));
    }
    return name;
  }
  const ret = {};
  const key_list = [];
  omr_keys.forEach((value, key) => {

    if (key in data) {
      if (!(value in ret)) {
        ret[value] = [];
      }
      if (!(key_list.includes(value))) {
        key_list.push(value);
      }

      ret[value].push(data[key]);
    }
  });

  if ('성명' in ret) {
    ret['성명'] = [convertName(ret['성명'])];
  }

  return {data: ret, key_list};
}

async function recognizeOMR(file) {
  if (file == null) { // health check
    const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/omr/inference`);
    return ret;
  }

  const base64Bytes = await toBase64(file);
  
  const ret = await recognizeImpl(null, `${ipLoopBack}/api/document/omr/inference`, { base64Image: base64Bytes } );
  const data = convertOMRKeys(ret.data);
  
  return {data: data.data, key_list: data.key_list};
}

export default {
  recognizeDocumentClassification,
  recognizeBusinessRegistration,
  recognizePassport,
  recognizeNutritionalInformation,
  recognizeIdcard,
  recognizeTable1,
  recognizeTable2,
  recognizeCreditcard,
  recognizeBankbook,
  recognizeFamilyRelations,
  recognizePrescription,
  recognizeMedicalDetailed,
  recognizeFinancialStatement,
  recognizeTrafficFine,
  recognizeGeneralTable,
  recognizeDocumentLayoutAnalysis,
  recognizeUltraimage,
  recognizeTestPaper,
  recognizeRemoveHandwriting,
  recognizeOMR
}
